import useIsSmall from "@/hooks/useIsSmall";
import { Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { FullContainer } from "../auth/style";
import DesktopLayout from "../dashboard/Desktop";

function FullLayout() {
  const { i18n } = useTranslation();
  const isSmall = useIsSmall();
  // const { pathname } = useLocation();
  return isSmall ? (
    <FullContainer dir={i18n.dir()} fluid p={0}>
      {/* <motion.div
        key={pathname}
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "-100%" }}
        transition={{ duration: 0.2 }}
        style={{ height: "100svh" }}
      ></motion.div> */}
      <Stack h="100svh" m="0" justify="start">
        <Stack
          style={{
            overflow: "hidden",
            overflowY: "auto",
            flexGrow: 1,
          }}
          id="dashboard-layout"
          justify="start"
          gap={0}
        >

          <Outlet />
        </Stack>
      </Stack>
    </FullContainer>
  ) : (
    <DesktopLayout />
  );
}

export default FullLayout;
